import { render, staticRenderFns } from "./CreateFormModal.vue?vue&type=template&id=6727facf&scoped=true&"
import script from "./CreateFormModal.vue?vue&type=script&lang=js&"
export * from "./CreateFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6727facf",
  null
  
)

export default component.exports